import { css, styled } from "styled-components";
import { parseSizeToken, useDesignTokens } from "@boi/react-design-tokens";

import { type $SizedProps } from "../types";

export const ToggleOutlineWrapper = styled.div<$SizedProps>`
  ${({ $toggleSize }) => {
    const { tokens } = useDesignTokens();
    const { toggle } = tokens;

    const width = parseSizeToken(toggle.size[$toggleSize].width);
    const height = parseSizeToken(toggle.size[$toggleSize].height);

    return css`
      cursor: pointer;
      width: ${width};

      outline-style: solid;
      border-radius: ${height};
      outline-offset: 0;
      outline-width: 0;

      &:has(input:disabled) {
        cursor: not-allowed;
      }

      &:has(input:focus-visible) {
        outline-color: ${toggle.focusRing.color};
        outline-width: ${toggle.focusRing.width};
        outline-offset: ${toggle.focusRing.offset};
      }
    `;
  }}
`;

export const CustomToggleWrapper = styled.div<$SizedProps>`
  ${({ $toggleSize }) => {
    const { tokens } = useDesignTokens();
    const { toggle } = tokens;

    const width = parseSizeToken(toggle.size[$toggleSize].width);

    return css`
      width: ${width};
      background-color: transparent;
    `;
  }}
`;
